import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import * as React from "react";
import { Link } from "react-router-dom";
import { catalogColumns } from "src/business/catalog/catalogColumns";
import { MdmTable } from "src/components/MdmTable";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ObjectsManager } from "../ObjectsManager";
import { managCatalogsStore as pageStore } from "./managCatalogsStore";

export const ManagementsCatalogs: React.FC = () => {
  const tools = (
    <>
      <RtColumnsSettingsButton store={pageStore.table} />
      <Link to={makeUrl(PageUrl.managementCatalogNew)}>
        <Button type="primary" icon={<PlusCircleOutlined />}>
          Создать
        </Button>
      </Link>
    </>
  );

  return (
    <ObjectsManager tab="catalogs">
      <ToolBox2 extraTools={tools} paddingMode="page">
        <MdmTable
          store={pageStore.table}
          columns={catalogColumns({ showScheme: true, records: true })}
          rowClick={{
            type: "link",
            builder: (row) =>
              makeUrl(PageUrl.managementCatalogEdit, { id: row.id }),
          }}
          resizableColumns
        />
      </ToolBox2>
    </ObjectsManager>
  );
};
